import apiUrl from "../../../constants";
import axios from "axios";
import { Validator } from "vee-validate";
import Paginate from "vuejs-paginate";
import VueElementLoading from "vue-element-loading";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";


export default {
  name: "emailConfig",
  components: { Paginate, VueElementLoading, Multiselect },
  props: [],

  data() {
    return {
      hubList: [],
      hubData: [],
      hub: {
        location_id:0,
        location_with_id:"Select All"
      },
      resultCount: 0,
      pagecount: 0,
      pageno: 0,
      count: 0,
      isLoading: false,
      hubLoading: false,
      commentModalShow: false,
      isActive: false,
      editUpdatedBy: "",
      editId: "",
      zoneName: "",
      locationType: "",
      locationName: "",
      editRMEmail: "",
      editStateEmail: "",
      editClusterEmail: "",
      editType: "",
      importCSVModalShow: false,
      csvFile: "",
      editStatus: false,
      allZoneLoading: false,
      existingData: "",
      isError: " ",
      importDataStatus: false,
      responseData: "",
      updateButton: false,
      getLocationData: [],
      reportlink: "",
      isUploading:false,
    };
  },
  computed: {},

  mounted() {
    var userToken = window.localStorage.getItem("accessuserToken");
    this.myStr = userToken.replace(/"/g, "");
    this.role = window.localStorage
      .getItem("accessrole")
      .toLowerCase()
      .replace(/\s/g, "");
    this.getLocations();
  },

  methods: {
    getLocations() {
      this.hubLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "getAllLocations",
        headers: {
          Authorization: "Bearer " + this.myStr,
        },
      }).then(
        (result) => {
          if (result.data.code == 200) {
            let filterData = result.data.data;
            this.hubList = [
              { location_id: 0, location_with_id: "Select All" },
              ...filterData,
            ];
            this.hubLoading = false;
          } else {
            this.hubLoading = false;
            // this.$alertify.error(result.data.message);
          }
        },
        (error) => {
          this.hubLoading = false;
          console.error(error);
          // this.$alertify.error(error);
        }
      );
    },

    onSubmit: function (event) {
      this.getLocationDetails();
    },

    getLocationDetails() {
      console.log(this.hub);
      
      this.isLoading = true;
      let payload = {
        location_id: this.hub ? this.hub.location_id : 0,
        offset: this.pageno,
        limit: 15,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "fetchLocationData",
        data: payload,
        headers: {
          Authorization: "Bearer " + this.myStr,
        },
      })
        .then((response) => {
          if (response.data.code == 200) {
            this.getLocationData = response.data.data;
            this.isLoading = false;
            let totalRows = response.data.count;
            this.resultCount = response.data.count;
            if (totalRows < 15) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(totalRows / 15);
            }
          } else {
            $alertify.error(response.data.message);
          }
        })
        .catch((error) => {
          $alertify.error(error);
        });
    },
    closeStatusRoleModal() {
      this.ReasonModalShow = false;
      this.RecExcModalShow = false;
      this.commentModalShow = false;
      this.importCSVModalShow = false;
      this.importDataStatus = false;
    },

    editSelectedDetails(data) {
      this.commentModalShow = true;
      this.existingData = data;
      const token = localStorage.getItem("access_token");
      const base64Url = token.split(".")[1];
      const jsonPayload = Buffer.from(base64Url, "base64").toString("utf8");
      (this.editId = data.location_id), (this.zoneName = data.zone.zone_name);
      this.locationType = data.location_type;
      this.locationName = data.location_name;
      this.editRMEmail = data.zone.rm_email;
      this.editStateEmail = data.state.state_email;
      this.editClusterEmail = data.cluster.cluster_email;
      this.editStatus = data.isactive;

      this.editUpdatedBy = JSON.parse(jsonPayload).email;
      // console.log(this.editUpdatedBy);
    },

    updateEmail() {
      if (
        this.editRMEmail == "" ||
        this.editStateEmail == "" ||
        this.editClusterEmail == ""
      ) {
        this.$alertify.error("Email required..!!");
        return false;
      }
      if (!this.isValidEmail) {
        this.$alertify.error("Invalid email format..!!");
        return false;
      }
      let payload = {
        location_id: this.editId,
        zone_name: this.zoneName,
        state_email: this.editStateEmail,
        cluster_email: this.editClusterEmail,
        rm_email: this.editRMEmail,
        updated_by: this.editUpdatedBy,
        isactive: this.editStatus,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "updateLocationData",
        data: payload,
        headers: {
          Authorization: "Bearer " + this.myStr,
        },
      })
        .then((result) => {
          if (result.data.code == 200) {
            this.$alertify.success(result.data.message);
            console.log(this.hub);
            
            this.getLocationDetails();
            this.commentModalShow = false;
          } else {
            this.$alertify.error(result.data.message);
          }
        })
        .catch((error) => {
          this.$alertify.error(error);
        });
    },

    resetForm() {
      // this.getLocations(),
        this.hub= {
          location_id:0,
          location_with_id:"Select All"
        },
        this.pageno = this.resultCount = 0;
        this.getLocationData=[];
    },

    importCSvModal() {
      this.importCSVModalShow = true;
    },
    handleFileUpload(event) {
      this.csvFile = event.target.files[0];
      if (this.csvFile) {
        const fileType = this.csvFile.type;
        const fileName = this.csvFile.name;

        // Check by MIME type or file extension
        if (fileType !== "text/csv" && !fileName.endsWith(".csv")) {
          this.$alertify.error("Only CSV files are allowed!");
          event.target.value = ""; // Clear the input
          return;
        }
        // console.log(this.csvFile, ">>>>>>>>>>>>>>");
      } else {
        this.$alertify.error("Please select a file first.");
        return;
      }
    },
    async uploadFile() {
      if (!this.csvFile) {
        this.$alertify.error("Please select a file first.");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.csvFile);
      // console.log(formData, ">>>>>>>>>>>>>>");
      this.isUploading=true;
      try {
        const response = await axios.post(
          apiUrl.api_url + "hubRelationsUpdate",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.importCSVModalShow = false;
        this.responseData = response.data.counters;
        this.importDataStatus = true;
        this.$alertify.success(response.data.message);
        console.log("Upload successful:", response.data);
        this.file = null;
        document.getElementById('fileInput').value = '';
        this.getLocations();
        this.isUploading=false;
      } catch (error) {
        this.isUploading=false;
        console.error("Error uploading file:", error);
        this.$alertify.error("error");
      }
    },

    exportCSV() {
      axios({
        method: "POST",
        url: apiUrl.api_url + "exportLocations",
        headers: {
          Authorization: "Bearer " + this.myStr,
        },
      }).then(
        (result) => {
          this.isLoading = false;
          if (result.data.code === 200) {
            const csvString = result.data.data;

            const csvBlob = new Blob([csvString], {
              type: "text/csv;charset=utf-8;",
            });

            const link = document.createElement("a");
            const csvBlobUrl = URL.createObjectURL(csvBlob);

            link.href = csvBlobUrl;
            link.download = "locations_data.csv";
            link.click();

            URL.revokeObjectURL(csvBlobUrl);
            // this.reportlink = csvBlobUrl;
            // window.open(this.reportlink);

            this.$alertify.success("Export Successful");
          }
        },
        (error) => {
          console.error(error);
          this.$alertify.error("Export Error");
          this.isLoading = false;
        }
      );
    },

    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 15;
      this.getLocationDetails()
    },
    isValidEmail(email) {
      const emailPattern = /^[a-zA-Z](?!.*\.\.)([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-z0-9-]+\.[a-z]{2,}$/;
      // console.log(emailPattern.test(email));
      return emailPattern.test(email);
    },
    generateCSV() {
      const data = [
        ["location_id", "location_name", "cluster_email", "state_email", "rm_email","zone_id", "zone_name", "isActive", "location_type"],
        ['090909',	'ABC','example@gmail.com','example1@gmail.com',	'test@gmail.com',	'2','West',	'TRUE','SC']
      ];
  
      const csvContent = data.map(row => row.join(",")).join("\n");
  
        // Create a Blob object with the CSV content
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
        // Create a link to download the file
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "sample_data.csv"; // Set the default file name
  
        // Trigger the download
        link.click();
    },
  },
  
};



// WEBPACK FOOTER //
// ./src/views/components/emailConfig/emailConfig.component.js